/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskIDRequestBody,
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody$outboundSchema,
} from "../components/riskidrequestbody.js";

export type RefreshOrganizationRemoteSessionIssuerMetadataSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type RefreshOrganizationRemoteSessionIssuerMetadataRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  riskIDRequestBody: RiskIDRequestBody;
};

/** @internal */
export type RefreshOrganizationRemoteSessionIssuerMetadataSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const RefreshOrganizationRemoteSessionIssuerMetadataSecurity$outboundSchema:
  z.ZodMiniType<
    RefreshOrganizationRemoteSessionIssuerMetadataSecurity$Outbound,
    RefreshOrganizationRemoteSessionIssuerMetadataSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function refreshOrganizationRemoteSessionIssuerMetadataSecurityToJSON(
  refreshOrganizationRemoteSessionIssuerMetadataSecurity:
    RefreshOrganizationRemoteSessionIssuerMetadataSecurity,
): string {
  return JSON.stringify(
    RefreshOrganizationRemoteSessionIssuerMetadataSecurity$outboundSchema.parse(
      refreshOrganizationRemoteSessionIssuerMetadataSecurity,
    ),
  );
}

/** @internal */
export type RefreshOrganizationRemoteSessionIssuerMetadataRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  RiskIDRequestBody: RiskIDRequestBody$Outbound;
};

/** @internal */
export const RefreshOrganizationRemoteSessionIssuerMetadataRequest$outboundSchema:
  z.ZodMiniType<
    RefreshOrganizationRemoteSessionIssuerMetadataRequest$Outbound,
    RefreshOrganizationRemoteSessionIssuerMetadataRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      riskIDRequestBody: RiskIDRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        riskIDRequestBody: "RiskIDRequestBody",
      });
    }),
  );

export function refreshOrganizationRemoteSessionIssuerMetadataRequestToJSON(
  refreshOrganizationRemoteSessionIssuerMetadataRequest:
    RefreshOrganizationRemoteSessionIssuerMetadataRequest,
): string {
  return JSON.stringify(
    RefreshOrganizationRemoteSessionIssuerMetadataRequest$outboundSchema.parse(
      refreshOrganizationRemoteSessionIssuerMetadataRequest,
    ),
  );
}
